import { Component, Inject, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { Restangular } from 'ngx-restangular';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';
import { AuthService } from "@app/common/services/auth.service";
import { ProjectTypesEnum } from "@app/ps/enums/project-types.enum";
import { RESTANGULAR_SYMAP } from '@app/common/services/restangular-symap.service';

@Component({
  selector: 'occupation-approve',
  templateUrl: './occupation-approve.component.html',
  styleUrls: ['./occupation-approve.component.scss'],
})
export class OccupationApproveComponent implements OnInit {

  occupationObject: OccupationModel;
  loading = true;
  saving = false;
  errorMessage: string;
  showApproveWarning: boolean;
  occupationUpdatePaused: boolean;
  occupationUpdatePausedReason: string;
  projectType: string;
  newConstructionObjects: any[] = [];
  isInvest: boolean;
  isAdditional: boolean;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private restangular: Restangular,
    private authService: AuthService,
    @Inject(RESTANGULAR_SYMAP) private restangularSymap: any,
  ) {
    this.onApprove = this.onApprove.bind(this);
    this.onReject = this.onReject.bind(this);
  }

  async ngOnInit() {
    const id = (<DialogConfigData>this.dialogConfig.data).occupationId;
    if (id) {
      await this.loadOccupation(id);
    } else {
      this.occupationObject = await (<DialogConfigData>this.dialogConfig.data).occupation;
    }
    this.occupationObject.constructionObjects = this.occupationObject.constructionObjects.filter(co=>!co.endDate);
    this.projectType = this.authService.getActualProject().type;
    this.isAdditional = this.projectType === ProjectTypesEnum.ADDITIONAL;
    this.isInvest = this.projectType === ProjectTypesEnum.INVEST;

    const project = this.authService.getActualProject();
    const freshProject = await this.restangularSymap
      .one('projects', project.id)
      .get()
      .toPromise();
    this.occupationUpdatePaused = !!freshProject.occupationUpdatePaused;
    this.occupationUpdatePausedReason = freshProject.occupationUpdatePausedReason;

    this.showApproveWarning = this.occupationObject.finalSolutionOtherChange && !(this.occupationObject.finalSolutionOtherChange.changeGeometry || this.occupationObject.finalSolutionOtherChange.changeWholeParcel);
    await this.loadConstructionObject();
    this.loading = false;
  }

  async loadConstructionObject() {
    if (this.occupationObject.finalSolutionOtherChange && this.occupationObject.finalSolutionOtherChange.newConstructionObjects) {
      this.newConstructionObjects = await Promise.all(
        this.occupationObject.finalSolutionOtherChange.newConstructionObjects.map(co =>
          this.restangular.one('construction-objects', co.id).get().toPromise()
        )
      );
    }
    this.newConstructionObjects = this.newConstructionObjects.filter(nco => !nco.endDate);
  }

  onApprove() {
    this.occupationObject.finalSolutionState = FinalSolutionStateEnum.APPROVED;
    this.occupationObject.finalSolutionNote = null;
    this.update();
  }

  onReject() {
    this.occupationObject.finalSolutionState = FinalSolutionStateEnum.REJECTED;
    this.update();
  }

  private async loadOccupation(occupationId: number) {
    this.occupationObject = await this.restangular.one('occupations', occupationId)
      .get({loadCollections: ['parcel.title.ownerships']})
      .toPromise();
  }

  private update() {
    this.errorMessage = null;
    this.saving = true;
    this.occupationObject.editMode = 'final-solution-type';
    return this.restangular
      .one('occupations', this.occupationObject.id)
      .customPUT(this.occupationObject)
      .toPromise()
      .then((result) => {
        this.dialogRef.close(result);
      })
      .catch((error) => {
        this.errorMessage = (error && error.data && error.data.message) || (error && error.message) || 'Neznámá chyba';
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
